module.exports = __webpack_public_path__ + "static/media/fallback.e349ecd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Panels/SharedComponents/Product/fallback.svg
// module id = 180
// module chunks = 0